// extracted by mini-css-extract-plugin
export default {"Question":"styles_Question__bZXY-","header":"styles_header__AlOqd","questionTitle":"styles_questionTitle__gefU0","answers":"styles_answers__yq7lH"};